import { t as tt } from 'i18next'
import * as React from 'react'
import { useState } from 'react'
import * as Api from 'src/api'
import { CloseIcon } from 'src/assets/icons/customIcons/Close'
import env from 'src/helpers/env'
import { Card } from 'src/tailwind/components/Card'

interface Props {
  readonly children: readonly React.ReactElement[]
}
export default function StagingHttpAuthGuard({
  children,
}: Props): React.ReactElement | readonly React.ReactElement[] | null {
  const isStaging = env.APP_ENV === 'STAGING'
  const [authorized, setAuthorized] = React.useState(() => !isStaging)
  const [cancelled, setCancelled] = useState(false)

  const checkIsAuthorized = async () => {
    if (authorized || !isStaging) return
    try {
      await Api.basicAuth()
      setAuthorized(true)
    } catch (error) {
      setAuthorized(false)
      setCancelled(true)
    }
  }

  React.useEffect(() => {
    void checkIsAuthorized()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const onClose = () => {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.location.assign('https://argus.iliauni.edu.ge')
    }
  }
  if (authorized) return children
  if (cancelled)
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center">
        <Card className="relative flex h-[200px] !w-auto flex-col items-end justify-center rounded-card px-8 py-4">
          <button
            onClick={onClose}
            type="button"
            className="absolute right-8 top-4 flex cursor-pointer items-center justify-center rounded-full p-[3px] duration-300 ease-in-out hover:bg-hover-icon"
            data-testid="closeModalButton"
          >
            <CloseIcon color="#000" />
          </button>
          <p className="text-base text-primaryTextColor">
            {tt('uncategorized:staging_http_auth_required_text')}{' '}
            <a href="https://argus.iliauni.edu.ge" rel="noreferrer" className="text-primaryBlueLink">
              https://argus.iliauni.edu.ge
            </a>
          </p>
        </Card>
      </div>
    )
  return null
}
